import { useQueryClient } from "react-query";

const getQueryData = (key: any): any => {
    const queryClient = useQueryClient();
    return queryClient.getQueryData(key);
};

export { getQueryData };
